var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"inputH48_01 W100 H2row",attrs:{"value":_vm.value,"rules":_vm.rules,"placeholder":_vm.placeholder,"label":_vm.label,"suffix":_vm.suffix,"outlined":_vm.outlined},on:{"input":_vm.getData},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }